import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/* eslint-disable max-lines */
import * as React from 'react';
import { createIcon } from '../../../internal/index.js';

// eslint-disable-next-line react/display-name
import { jsx as _jsx } from "react/jsx-runtime";
const IconComponent = /*#__PURE__*/React.forwardRef((props, ref) => {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.93 2.48C3.307 2.48 2 3.776 2 5.36c0 2.12 1.476 4.121 3.181 5.692A19.988 19.988 0 0 0 8 13.205a19.988 19.988 0 0 0 2.819-2.152C12.524 9.48 14 7.48 14 5.36c0-1.585-1.306-2.88-2.93-2.88-.928 0-1.753.423-2.29 1.085L8 4.524l-.78-.959a2.942 2.942 0 0 0-2.29-1.084ZM8 14.365l-.49.863h-.001l-.002-.002-.006-.003-.019-.01a7.205 7.205 0 0 1-.307-.182 21.988 21.988 0 0 1-3.357-2.528C2.025 10.848 0 8.347 0 5.36 0 2.67 2.212.5 4.93.5 6.09.5 7.158.896 8 1.557A4.956 4.956 0 0 1 11.07.5C13.788.5 16 2.67 16 5.36c0 2.987-2.024 5.488-3.819 7.142a21.994 21.994 0 0 1-3.663 2.71l-.019.01-.006.003-.002.002L8 14.364Zm0 0 .49.863L8 15.5l-.49-.273.49-.863Zm-.49-.863Z",
      fill: "currentColor"
    })
  }));
});

/**
 * Компонент иконки
 *
 * Некоторые иконки красятся в любые цвета из палитры, некоторые имеют зафиксированные цвета.
 */
export const IconToggleHeartOff16 = createIcon(IconComponent);